/** Presets aceitos pela API de relatórios financeiros. */
export type FinancialReportPeriodPreset =
  | 'last7'
  | 'last30'
  | 'last90'
  | 'currentMonth'
  | 'previousMonth';

export const FINANCIAL_REPORT_PERIOD_OPTIONS: {
  value: FinancialReportPeriodPreset;
  label: string;
}[] = [
  { value: 'last7', label: 'Últimos 7 dias' },
  { value: 'last30', label: 'Últimos 30 dias' },
  { value: 'last90', label: 'Últimos 90 dias' },
  { value: 'currentMonth', label: 'Mês atual' },
  { value: 'previousMonth', label: 'Mês anterior' }
];

export interface FinancialReportKeyCountAmount {
  key: string;
  count: number;
  amount: number;
}

export interface FinancialReportEntityCountAmount {
  entityId?: number;
  entityName: string;
  count: number;
  amount: number;
}

export interface FinancialReportCostCenterCountAmount {
  costCenterId?: number;
  costCenterName: string;
  count: number;
  amount: number;
}

export interface FinancialReportAgingBucket {
  bucket: string;
  label: string;
  count: number;
  amount: number;
}

export interface ApPositionSummaryItem {
  id: number;
  documentNumber?: string;
  documentType?: string;
  status?: string;
  description?: string;
  category?: string;
  issueDate?: string;
  dueDate?: string;
  paymentDate?: string;
  originalAmount?: number;
  amountToPay?: number;
  amountPaid?: number;
  openAmount?: number;
  supplierId?: number;
  supplierName?: string;
  costCenterId?: number;
  costCenterCode?: string;
  costCenterName?: string;
  installmentNumber?: number;
  totalInstallments?: number;
  agingBucket?: string;
  agingLabel?: string;
  daysPastDue?: number;
  daysUntilDue?: number;
}

export interface ApPositionSummarySection {
  count: number;
  totalAmount: number;
  byCategory?: FinancialReportKeyCountAmount[];
  bySupplier?: FinancialReportEntityCountAmount[];
  items?: ApPositionSummaryItem[];
  itemsTotal?: number;
  itemsReturned?: number;
  itemsTruncated?: boolean;
}

export interface ApPositionSummaryPayload {
  reportTitle: string;
  periodPreset: FinancialReportPeriodPreset;
  periodDescription: string;
  paymentPeriodFrom: string;
  paymentPeriodTo: string;
  referenceDate: string;
  filters?: { includeChildCostCenters?: boolean; costCenterId?: number };
  openAging: {
    buckets: FinancialReportAgingBucket[];
    totalCount: number;
    totalAmount: number;
  };
  openByStatus: FinancialReportKeyCountAmount[];
  openByCategory: FinancialReportKeyCountAmount[];
  openBySupplier: FinancialReportEntityCountAmount[];
  openByCostCenter: FinancialReportCostCenterCountAmount[];
  pending: ApPositionSummarySection;
  overdue: ApPositionSummarySection;
  paidInPeriod: ApPositionSummarySection;
  pendingCount: number;
  pendingAmount: number;
  overdueCount: number;
  overdueAmount: number;
  paidInPeriodCount: number;
  paidInPeriodAmount: number;
}

export interface ApPositionSummaryResponse {
  reportId: string;
  format: string;
  periodFrom: string;
  periodTo: string;
  generatedAtUtc: string;
  summary: ApPositionSummaryPayload;
}

export interface ApPositionSummaryQuery {
  period: FinancialReportPeriodPreset;
  costCenterId?: number | null;
  includeChildCostCenters?: boolean;
}
